import {observable, computed} from 'mobx';

export default class MarkupTemplateThemeSettings {
	/** @type {String} */
	@observable groups_block_template;
	/** @type {Boolean} */
	@observable is_groups_block_template_default;
	/** @type {String} */
	@observable simple_group_template;
	/** @type {Boolean} */
	@observable is_simple_group_template_default;
	/** @type {String} */
	@observable photo_group_template;
	/** @type {Boolean} */
	@observable is_photo_group_template_default;
	/** @type {String} */
	@observable color_group_template;
	/** @type {Boolean} */
	@observable is_color_group_template_default;

	constructor(settings) {
		if (settings) {
			this.groups_block_template = settings.groups_block_template;
			this.is_groups_block_template_default = settings.is_groups_block_template_default;
			this.simple_group_template = settings.simple_group_template;
			this.is_simple_group_template_default = settings.is_simple_group_template_default;
			this.photo_group_template = settings.photo_group_template;
			this.is_photo_group_template_default = settings.is_photo_group_template_default;
			this.color_group_template = settings.color_group_template;
			this.is_color_group_template_default = settings.is_color_group_template_default;
		}
	}

	@computed get is_default() {
		return this.is_groups_block_template_default
			&& this.is_simple_group_template_default
			&& this.is_photo_group_template_default
			&& this.is_color_group_template_default;
	}
}